import { useAppPagesContext } from '@/context/AppPagesContext'

import { BuilderTopBarCore } from '../../__project__/BuilderTopBarCore'

/**
 * BuilderTopBar
 *
 * @mode preview (builder) only
 */
export const BuilderTopBar = () => {
  const { activePage, activePageClient } = useAppPagesContext()

  if (!activePage || !activePageClient) return null

  return <BuilderTopBarCore page={activePage} pageClient={activePageClient} />
}
